import Button from 'components/shared/Buttons/Button';

const HeaderActions = ({ openModal }) => {
  return (
    <div>
      <Button
        text="New Admin User"
        icon="add-square-mono"
        size="small"
        transparent
        iconColor="white"
        onClick={openModal}
        textClassName="whitespace-nowrap"
        data-qa="new-staff-member-btn"
      />
    </div>
  );
};

export default HeaderActions;
